export class APIWrapperBase {
    public resetServerConfig(protocol: string, baseUrl: string, port: number): void {}
}